import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface JobApplication {
    _id: string;
    status: string;
    updatedAt?: string;
    [key: string]: any;
}

interface JobApplicationState {
    dataSource: JobApplication[];
}

const initialState: JobApplicationState = {
    dataSource: [],
};

const jobApplicationSlice = createSlice({
    name: "jobApplications",
    initialState,
    reducers: {
        setJobApplications(state, action: PayloadAction<JobApplication[]>) {
            state.dataSource = action.payload;
        },
        updateJobApplicationStatus(
            state,
            action: PayloadAction<{ recordId: string; newStatus: string }>
        ) {
            const { recordId, newStatus } = action.payload;
            state.dataSource = state.dataSource.map((app) =>
                app._id === recordId
                    ? { ...app, status: newStatus, updatedAt: new Date().toISOString() }
                    : app
            );
        },
    },
});

export const { setJobApplications, updateJobApplicationStatus } =
    jobApplicationSlice.actions;
export default jobApplicationSlice.reducer;
